export enum PaymentMethodChannel {
  WalkIn = 1,
  Online = 2
}
export enum PaymentMethodsEnum {
  NoPaymentRequired=0,
  Cash = 1,
  VisaMachine = 2,
  Cheque = 3,
  ACH = 4,
  AccountCredit = 5,
  PayPal = 6,
  PayTabs = 7
}
export enum PaymentGatewayMethodEnum
{
    Cash = 1,
    CreditCard = 2,
    Cheque = 3,
    ACH = 4,
    AccountCredit = 5,
    PayPal = 6,
    AmericanExpress = 7,
    MasterCard = 8,
    Mada = 9,
    STCPay = 10,
    UnionPay = 11,
    Visa=12
}
export enum PaymentMethodScopes {
  CarRental = 1,
}
export enum RentalServiceDeliveryChannel {
  Walkin = 1,
  Online = 2,
  EZRent = 3,
  Mobile = 4
}
export enum DepositeType {
  FullPaymnet = 1,
  SecurityDeposite = 2
}
export enum PaymentMode {
  New = 1,
  Edit = 2,
  SeparatePay = 3,
}
export enum ProceedPaymentResponseResult
{
  Success = 1,
  Failed = 2,
  PayPalPaymentMethodDoesNotActiveOrAvailableForOnline = 3,
  ThereIsNoPaymentMethodAvailable = 4,
  CustomerDoesNotHaveEnoughCredit = 5,
  YouCanNotContinueWithoutPay = 6,
  Required3DAuth = 7,
  YouTookTooMuchTime =8
}
export enum PaymentSharedComponentErrors
{
  NoAmount = 1,

}
